import { base44 } from '@/api/base44Client';

// One cached server call per page load (per language) for the lists every visitor needs.
const pending = {};

export function getPublicLists(lang = 'en') {
  if (!pending[lang]) {
    pending[lang] = base44.functions.invoke('publicLists', { lang })
      .then(res => res.data || {})
      .catch(() => { delete pending[lang]; return {}; });
  }
  return pending[lang];
}